"use client";


import type { MouseEvent, ReactNode } from "react";

import { cn } from "@/lib/utils";

export default function HeroReadMore({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    document
      .querySelector(".category-footer")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn("text-lg underline hover:no-underline", className)}
    >
      {children}
    </button>
  );
}
